<template>
	<div>
		<div v-if="!show_historico" class="animate__animated animate__fadeIn">
			<div class="row">
				<div class="col">
					<h5 class="font-weight-bold">Convivência Familiar e Comunitária</h5>
				</div>
				<div class="col text-right">
					<p class="font-weight-light font-italic">
						<a
							href="#"
							class="router-link-exact-active active"
							@click="show_historico = true"
						>
							<i class="fas fa-history"></i> Histórico
						</a>
					</p>
				</div>
			</div>
			<form @submit.prevent="submit" ref="addItem">
				<div class="row mt-3">
					<form-input
						v-model="convivencia.qtd_mora_estado"
						grid="6"
						label="Há quantos anos a família mora neste estado?"
					/>

					<form-input
						v-model="convivencia.qtd_mora_municipio"
						grid="6"
						label="Há quantos anos a família mora no município?"
					/>

					<form-input
						v-model="convivencia.qtd_mora_bairro"
						grid="12"
						label="Há quantos anos a família mora no bairro atual?"
					/>

					<form-select
						v-model="convivencia.discriminacao_convivencia"
						grid="12"
						label="A família, ou algum de seus membros, é vítima de ameaças ou de discriminação na comunidade onde reside?"
						:itens="$root.arrays.pergunta"
					/>

					<form-select
						v-model="convivencia.apoio_parentes"
						grid="12"
						label="A família possui parentes que residam próximo ao seu local de moradia e que constituam rede de apoio e solidariedade?"
						:itens="$root.arrays.pergunta"
					/>

					<form-select
						v-model="convivencia.apoio_vizinhos"
						grid="12"
						label="A família possui vizinhos que constituam rede de apoio e solidariedade?"
						:itens="$root.arrays.pergunta"
					/>

					<form-select
						v-model="convivencia.apoio_grupo_comunitario"
						grid="12"
						label="A família, ou algum de seus membros, participa de grupos religiosos, comunitários ou outros grupos/instituições que constituam rede de apoio e solidariedade?"
						:itens="$root.arrays.pergunta"
					/>

					<form-select
						v-model="convivencia.grupos_sociais_defesa"
						grid="12"
						label="A família, ou algum de seus membros, participa de movimentos sociais, sindicatos, organizações comunitárias, Conselhos ou quaisquer outras ações ou instituições voltadas para organização política e defesa de interesses coletivos?"
						:itens="$root.arrays.pergunta"
					/>

					<form-select
						v-model="convivencia.cri_ado_acesso_lazer"
						grid="12"
						label="Existe alguma criança ou adolescente do grupo familiar que não tem acesso a atividades de lazer, recreação e convívio social?"
						:itens="$root.arrays.pergunta_cri_ado_acesso_lazer"
					/>

					<form-select
						v-model="convivencia.idoso_acesso_lazer"
						grid="12"
						label="Existe alguma pessoa idosa do grupo familiar que não tem acesso a atividades de lazer, recreação e convívio social?"
						:itens="$root.arrays.pergunta"
					/>

					<form-select
						v-model="convivencia.dependente_cuidados"
						grid="12"
						label="Há pessoas dependentes (crianças, pessoas idosas dependentes ou pessoas com deficiência) que permanecem períodos do dia em casa sem a companhia de um adulto?"
						:itens="$root.arrays.pergunta_dependente_cuidados"
					/>

					<form-select
						v-model="convivencia.relacoes_conjugais"
						grid="12"
						label="Percepção/Avaliação do técnico sobre as relações conjugais na família, se for o caso"
						:itens="$root.arrays.relacoes_conjugais_familia"
					/>

					<!-- <form-input v-model="convivencia.tecnico" grid="6" label="Técnico" />

					<form-calendar v-model="convivencia.data" grid="6" label="Data" /> -->

					<form-select
						v-model="convivencia.relacoes_responsaveis"
						grid="12"
						label="Percepção/Avaliação do técnico sobre as relações entre pais/responsáveis e os filhos inclusive entre o padrasto ou madrasta com o(s) enteados(as), se for o caso"
						:itens="$root.arrays.relacoes_conjugais_familia"
					/>

					<form-select
						v-model="convivencia.relacoes_entre_irmaos"
						grid="12"
						label="Percepção/Avaliação do técnico sobre as relações entre os irmãos, se for o caso"
						:itens="$root.arrays.relacoes_conjugais_familia"
					/>

					<form-select
						v-model="convivencia.relacoes_conflituosas_outros"
						grid="12"
						label="Indique se há relações conflituosas envolvendo outros indivíduos que residam no domicílio?"
						:itens="$root.arrays.relacoes_conflituosas_outros"
					/>

					<form-textarea
						v-model="convivencia.observavoes_comunitaria"
						grid="12"
						label="Outras observações referentes ao diagnóstico das condições de convivência familiar e comunitária"
					/>
					<div class="col-md-9">
						<div class="float-left mt-2 mr-3">
							<toggle-button
								:sync="true"
								color="#5685D8"
								id="abrigo"
								name="abrigo"
								v-model="item.cadastrarConvivencia"
								class="float-left mr-3"
							/>
							Cadastrar uma nova convivência familiar e comunitária?
						</div>
					</div>

					<div class="col-md-3 text-right">
						<button class="btn btn-success btn-submit" data-style="zoom-in" type="submit">
							<i class="mdi mdi-content-save" />
							{{ $t("Salvar") }}
						</button>
					</div>
				</div>
			</form>
		</div>
		<div v-else>
			<Historico @voltar="show_historico = false" :familia-id="$route.params.id" />
		</div>
	</div>
</template>
<script>
import Historico from "../historico/Convivencia";
export default {
	components: { Historico },
	props: ["item"],
	data() {
		return {
			loading: false,
			convivencia: {},
			show_historico: false,
		};
	},
	mounted() {
		if (this.item.convivencia != null) {
			this.convivencia = this.item.convivencia;
		}
	},
	methods: {
		submit() {
			this.item.convivencia = this.convivencia;
			this.$emit("submit");
		},
	},
};
</script>

